var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            /*$('.home-animation').on('mousemove', (event: MouseEvent) => {
              if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        
              $('.home-animation-text').css({ left: event.clientX, top: event.clientY - parseInt($('.home-animation').css('margin-top'))});
            });
        
            $('.home, .page-template-page-template-coming-soon').on('touchmove', (event: TouchEvent) => {
              $('.home-animation-text').css({ left: event.touches[0].clientX, top: event.touches[0].clientY - parseInt($('.home-animation').css('margin-top')) });
            });*/
            // Select a random image from a tags in .home-image and set it as background of .home-animation
            const homeImageLinks = $('.home-image a');
            if (homeImageLinks.length > 0 && Math.random() < 0.5) {
                $('.home-animation').addClass('bg-white');
                const randomIndex = Math.floor(Math.random() * homeImageLinks.length);
                const randomImageLink = homeImageLinks.eq(randomIndex);
                const imageUrl = randomImageLink.attr('href');
                // Load the image to ensure it's cached before setting it as background
                console.log('Preloading image:', imageUrl);
                const image = new Image();
                image.onload = () => {
                    $('.home-image').css('background-image', `url(${imageUrl})`).addClass('has-background');
                };
                image.src = imageUrl;
            }
            this.success();
        });
    }
}
